import * as _ from 'underscore';

import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { CreativeAdSize, CreativePerformance, CreativeStats } from '../creative-detail-v2/creative-detail.interface';
import { CreativePerformanceV1Component } from '../creative-performace-v1/creative-performance-v1.component';

@Component({
	selector: 'app-creative-performance-v7',
	styleUrls: ['./creative-performance-v7.component.css'],
	templateUrl: './creative-performance-v7.component.html'
})
export class CreativePerformanceV7Component extends CreativePerformanceV1Component implements OnInit {
	public carouselIndex = 1;
	@Input() metricsarray: any;
	@Input() secondarykey: string;
	public decodedMetricsArray: any;
	public immutableMetrics: any;
	public isOverviewSem: boolean;
	public placeholderImage: string = '/assets/images/no-display-creative.png';
	public socialWithoutVideoMetrics = [
		{
			displayName: 'Impressions',
			displayOrder: 1,
			showPercent: false,
			value: 'impressions'
		},
		{
			displayName: '',
			displayOrder: 2,
			showPercent: false,
			value: ''
		},
		{
			displayName: 'Clicks',
			displayOrder: 3,
			showPercent: false,
			value: 'clicks'
		},
		{
			displayName: '',
			displayOrder: 4,
			showPercent: false,
			value: ''
		},
		{
			displayName: 'Click Rate',
			displayOrder: 5,
			showPercent: true,
			value: 'clickRate'
		},
		{
			displayName: '',
			displayOrder: 6,
			showPercent: false,
			value: ''
		}
	];
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.selectedIndex = 0;
			this.requestData();
			if (this.carousel && this.carousel.reset) {
				this.carousel.reset();
			}
		});
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: true,
			point: {
				visible: true
			},
			touch: true,
			velocity: 0.2
		};
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.decodedMetricsArray = JSON.parse(decodeURI(this.metricsarray));
		this.immutableMetrics = JSON.parse(decodeURI(this.metricsarray));
		this.isOverviewSem = this.sectiontitle.indexOf('SEM') !== -1;
		this.legend.forEach((legendItem, index) => {
			if (index === 0) {
				this.legend[index].selected = true;
				this.legend[index].active = true;
			} else {
				this.legend[index].selected = false;
				this.legend[index].active = false;
			}
		});
	}

	getMetricsArray(creative: any): any[] {
		if (creative && creative.isSocial) {
			if (creative.percentRate25 > 0) {
				return this.decodedMetricsArray;
			}
			return this.socialWithoutVideoMetrics;
		}
		return this.decodedMetricsArray;
	}

	processResponseData(responseData: any, index?: number): void {
		let arrayIndex = index ? index : 0;
		if (responseData.length > 0) {
			const dateSet = {
				depricatedDate: this.analyticsDataModel.depricatedDate,
				endDate: this.analyticsDataModel.endDate,
				goLiveDate: this.analyticsDataModel.goLiveDate,
				startDate: this.analyticsDataModel.startDate
			};
			this.decodedMetricsArray = UtilityService.checkForVisibilityPermissions(this.immutableMetrics, dateSet);
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			this.creatives = _.sortBy(_.sortBy(this.creatives, 'creativeName').reverse(), this.legend[0].value).reverse();
			this.creatives = this.creatives.splice(0, this.showOnly);
			const videoCreatives = _.where(this.creatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			if (this.isOverviewSem && !this.creatives[arrayIndex]['creativeStats']) {
				this.getAdData(this.creatives[arrayIndex], true, arrayIndex);
			}
			this.generateGraphData();
			this.hasGraphData = true;
		} else {
			this.hasData = false;
		}
	}

	getAdData(ad, flag, index): any {
		if (flag) {
			this.showLoad = true;
			this.analyticsService
				.processCustomServiceRequest(this.secondarykey, ad['ad_id'], ad['ad_type'], flag)
				.subscribe((response: any) => {
					this.showLoad = false;
					if (response.data) {
						this.hasData = true;
						if (response.data.creatives_by_month) {
							this.creatives[index]['creativeStats'] = this.mapResponseToCreativeStats(
								response.data.creatives_by_month
							);
							this.responseData.forEach((item) => {
								if (item.ad_id == ad['ad_id']) {
									item.creatives_by_month = response.data.creatives_by_month;
								}
							});
							this.responseData.filter((item) => item.ad_id == ad['ad_id'])[0]['creativeStats'] =
								response.data.creatives_by_month;
						}
						this.creatives[index]['graphData'] = this.generateGraphDataByCreative(
							this.creatives[index]['creativeStats']
						);
						this.generateGraphData(index);
					} else {
						this.hasData = false;
					}
				});
		}
	}

	mapResponseDataToInterface(responseData: any): CreativePerformance[] {
		let creativePerformances: CreativePerformance[] = [];
		for (const response of responseData) {
			const creativeObj: any = {};
			let location = '';
			const siteLinksArr = [];
			const structuredSnippetExtnArr = [];
			const calloutsExtnArr = [];
			let locationObj = {};
			let siteLinks = [];
			let structuredSnippetExtn = [];
			let calloutsExtn = [];
			creativeObj.absTopImpressionRate = UtilityService.isUndefinedOrNull(response.abs_top_impression_share)
				? 0
				: parseFloat(response.abs_top_impression_share);
			creativeObj.absTopImpression = UtilityService.isUndefinedOrNull(response.top_impression_share)
				? 0
				: parseFloat(response.top_impression_share);
			creativeObj.creativeName = response.creative_name ? response.creative_name : response.ad_headline;
			creativeObj.creativeName = creativeObj.creativeName ? creativeObj.creativeName : response.name;
			creativeObj.ad_title = UtilityService.isUndefinedOrNull(response.ad_title)
				? ''
				: response.ad_title == ''
				? ''
				: response.ad_title;
			creativeObj.versionId = UtilityService.isUndefinedOrNull(response.cup_version_id)
				? 0
				: parseFloat(response.cup_version_id);
			creativeObj.clicks = UtilityService.isUndefinedOrNull(response.clicks) ? 0 : parseFloat(response.clicks);
			creativeObj.iframeUrl = UtilityService.isUndefinedOrNull(response.iframe_url) ? null : response.iframe_url;
			creativeObj.adInteractions = UtilityService.isUndefinedOrNull(response.ad_interactions)
				? 0
				: parseFloat(response.ad_interactions);
			creativeObj.adInteractionRate = UtilityService.isUndefinedOrNull(response.interaction_rate)
				? 0
				: parseFloat(response.interaction_rate);
			creativeObj.impressions = UtilityService.isUndefinedOrNull(response.impressions)
				? 0
				: parseFloat(response.impressions);
			creativeObj.clickRate = UtilityService.isUndefinedOrNull(response.click_rate)
				? UtilityService.isUndefinedOrNull(response.clickthroughrate)
					? creativeObj.impressions > 0
						? ((creativeObj.clicks / creativeObj.impressions) * 100).toFixed(2)
						: 0
					: parseFloat(response.clickthroughrate)
				: parseFloat(response.click_rate);
			creativeObj.individualImpressions = response.individual_impressions
				? parseFloat(response.individual_impressions)
				: null;
			creativeObj.isIAB = UtilityService.isUndefinedOrNull(response.isIAB)
				? false
				: Number(response.isIAB)
				? true
				: false;
			creativeObj.isNative = UtilityService.isUndefinedOrNull(response.isNative)
				? false
				: Number(response.isNative)
				? true
				: false;
			creativeObj.native = response.native;
			creativeObj.enablePreviewContent = false;
			// TODO: Change logic on figuring out if creative is ctv or preroll
			creativeObj.callExtension = response && response.call_extn ? JSON.parse(response.call_extn)[0][1] : '';
			creativeObj.isCtv = this.sectiontitle.indexOf('CTV') !== -1 || this.sectiontitle.indexOf('Connected TV') !== -1;
			creativeObj.isSocial = this.sectiontitle.indexOf('Social') !== -1;
			creativeObj.isRadio =
				this.sectiontitle.indexOf('Radio') !== -1 || this.sectiontitle.indexOf('Streaming Audio') !== -1;
			const locationArr = [];
			if (response.location_extn) {
				locationObj = JSON.parse(response.location_extn)[0];
				for (const prop in locationObj) {
					if (parseInt(prop, 10) > 1 && parseInt(prop, 10) < 8) {
						locationArr.push(locationObj[prop]);
					}
				}
				location = locationArr.join(', ');
				creativeObj.location = location;
			}
			if (response.structuredsnippet_extn) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] !== '' ? item['2'].join(', ') : item['2']
					});
				}
			}
			if (response.callouts_extn) {
				calloutsExtn = JSON.parse(response.callouts_extn);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}
			try {
				creativeObj.url = typeof response.url == 'string' ? response.url : JSON.parse(response.url)[0];
			} catch (error) {
				creativeObj.url = response.url;
			}
			creativeObj.adHeadline = UtilityService.isUndefinedOrNull(response.ad_headline) ? '' : response.ad_headline;
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.avgPosition = parseFloat(response.avg_position);
			creativeObj.adgroup_name = UtilityService.isUndefinedOrNull(response.adgroup_name) ? '' : response.adgroup_name;
			creativeObj.adgroup_id = UtilityService.isUndefinedOrNull(response.adgroup_id) ? '' : response.adgroup_id;
			creativeObj.ad_id = UtilityService.isUndefinedOrNull(response.ad_id) ? '' : response.ad_id;
			creativeObj.ad_type = UtilityService.isUndefinedOrNull(response.ad_type) ? '' : response.ad_type;
			creativeObj.final_url = UtilityService.isUndefinedOrNull(response.creative_final_urls)
				? ''
				: response.creative_final_urls;
			creativeObj.ad_description = UtilityService.isUndefinedOrNull(response.ad_description)
				? ''
				: response.ad_description;
			creativeObj.top_impression_share = parseFloat(response.top_impression_share);
			creativeObj.abs_top_impression_share = parseFloat(response.abs_top_impression_share);
			creativeObj.topImpressionShare = parseFloat(response.top_impression_share).toFixed(2);
			creativeObj.absTopImpressionShare = parseFloat(response.abs_top_impression_share).toFixed(2);
			creativeObj.description = UtilityService.isUndefinedOrNull(response.description) ? '' : response.description;
			const temCreativeDesc = creativeObj.description.split('|');
			if (temCreativeDesc.length > 1) {
				creativeObj.description = temCreativeDesc;
			}
			if (response.sitelink_extn) {
				siteLinks = JSON.parse(response.sitelink_extn);
				for (const item of siteLinks) {
					siteLinksArr.push({
						// tslint:disable-next-line: prefer-template
						description: (item['3'] || '') + ' ' + (item['4'] || ''),
						heading: item['1'],
						link: item['5'][0]
					});
				}
			}
			creativeObj.isIframeExpired = response.is_iframe_expired;
			creativeObj.snapshotImage = response.snapshot_path;
			creativeObj.hasSnapshotImage = !UtilityService.isUndefinedOrNull(response.snapshot_path);
			creativeObj.isVideoCreative = !UtilityService.isUndefinedOrNull(response.video_url);
			if(creativeObj.isSocial) {
				creativeObj.creativeThumbnail = response.creative_thumbnail_image && response.creative_thumbnail_image !== "" ? decodeURIComponent(response.creative_thumbnail_image.slice(response.creative_thumbnail_image.includes('http') ? response.creative_thumbnail_image.lastIndexOf('http') : 0)) : null;
				UtilityService.checkImageURLExpired(creativeObj.creativeThumbnail)
				.then((exists) => {
					if (!exists) {
					creativeObj.creativeThumbnail = null;
					}
				});
			} else {
			creativeObj.creativeThumbnail = response.creative_thumbnail_image
				? !UtilityService.checkEncodeURI(response.creative_thumbnail_image)
					? encodeURI(response.creative_thumbnail_image)
					: response.creative_thumbnail_image
				: this.placeholderImage;
			}
			if (creativeObj.isVideoCreative) {
				creativeObj.creativeThumbnail = creativeObj.isSocial ?response.thumbnail_image ? response.thumbnail_image : this.placeholderImage : null;
				creativeObj.creativeVideo = response.video_url;
			}
			creativeObj.completionRate = UtilityService.isUndefinedOrNull(response.completion_rate)
				? 0
				: parseFloat(response.completion_rate).toFixed(2);
			creativeObj.completions = UtilityService.isUndefinedOrNull(response.completion_value)
				? 0
				: parseInt(response.completion_value, 10);
			if (creativeObj.isRadio) {
				creativeObj.audioURL = response.audio_url;
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response.completion_rate)
					? 0
					: parseFloat(response.completion_rate).toFixed(2);
				creativeObj.completions = UtilityService.isUndefinedOrNull(response.completion_value)
					? 0
					: parseInt(response.completion_value, 10);
			}
			if (creativeObj.isSocial) {
				creativeObj.percentRate25 = response['25_percent_rate'];
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response['100_percent_rate'])
					? 0
					: parseFloat(response['100_percent_rate']).toFixed(2);
				creativeObj.completions = UtilityService.isUndefinedOrNull(response['100_percent_value'])
					? 0
					: parseInt(response['100_percent_value'], 10);
				// this.socialVideoCreative = creativeObj.percentRate25>0 ? true : false;
			}
			if (response.creatives_by_ads) {
				creativeObj.adSizes = !creativeObj.isVideoCreative
					? this.mapResponseToAdSizes(response.creatives_by_ads ? response.creatives_by_ads : [])
					: ({} as { string: CreativeAdSize });
				creativeObj.hasAdSizes = !creativeObj.isVideoCreative ? !!response.creatives_by_ads : false;
			}
			if (response.creatives_by_month) {
				creativeObj.creativeStats = this.mapResponseToCreativeStats(response.creatives_by_month);
			}
			creativeObj.graphData = this.generateGraphDataByCreative(creativeObj.creativeStats);

			if (response.callouts_extn_attribute_values) {
				calloutsExtn = JSON.parse(response.callouts_extn_attribute_values);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}

			if (response.structuredsnippet_extn_attribute_values) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn_attribute_values);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] != '' ? item['2'].join(', ') : item['2']
					});
				}
			}

			siteLinks =
				!UtilityService.isUndefinedOrNull(response.sitelink_extn_attribute_values) &&
				response.sitelink_extn_attribute_values !== ''
					? JSON.parse(response.sitelink_extn_attribute_values)
					: [];

			for (const item of siteLinks) {
				siteLinksArr.push({
					heading: item['1'] || '',
					description: (item['3'] || '') + ' ' + (item['4'] || ''),
					link: item['5'][0] || ''
				});
			}

			locationObj =
				!UtilityService.isUndefinedOrNull(response.location_extn_attribute_values) &&
				response.location_extn_attribute_values !== ''
					? JSON.parse(response.location_extn_attribute_values.replaceAll('\\"', '"'))[0]
					: {};
			for (let prop in locationObj) {
				if (parseInt(prop) > 1 && parseInt(prop) < 8) {
					locationArr.push(locationObj[prop]);
				}
			}
			location = locationArr.join(', ');
			creativeObj.location = location;

			creativeObj.calloutsExtn = calloutsExtnArr.length > 0 ? calloutsExtnArr : [];
			creativeObj.structuredSnippetExtn = structuredSnippetExtnArr;
			creativeObj.siteLinks = siteLinksArr;

			creativeObj.responsiveAdTitle = !UtilityService.isUndefinedOrNull(response.responsive_ad_title)
				? JSON.parse(response.responsive_ad_title)
				: [];
			creativeObj.responsiveAdDescription = !UtilityService.isUndefinedOrNull(response.responsive_ad_title)
				? JSON.parse(response.responsive_ad_title)
				: [];

			if (creativeObj.ad_type == 'RESPONSIVE_SEARCH_AD') {
				creativeObj.description = [];
				creativeObj.adHeadline =
					creativeObj.responsiveAdTitle.length > 1
						? creativeObj.responsiveAdTitle[0]['text'] +
						  ' + ' +
						  (creativeObj.responsiveAdTitle.length - 1) +
						  ' more headlines'
						: creativeObj.responsiveAdTitle.length == 1
						? creativeObj.responsiveAdTitle[0]['text']
						: '';
				creativeObj.responsiveAdDescription.forEach((item) => creativeObj.description.push(item['text']));
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_creative_final_urls)
					? UtilityService.isUndefinedOrNull(response.creative_final_urls)
						? ''
						: response.creative_final_urls
					: response.scaa_creative_final_urls;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.toUpperCase().includes('DYNAMIC')) {
				creativeObj.description = [];
				creativeObj.adHeadline = 'Dynamically generated headline';
				let descpt1 = response.scaa_description1
					? response.scaa_description1.substring(0, 90)
					: response.description1
					? response.description1.substring(0, 90)
					: '';
				let descpt2 = response.scaa_description2
					? response.scaa_description2.substring(0, 90)
					: response.description2
					? response.description2.substring(0, 90)
					: '';
				creativeObj.description.push(descpt1, descpt2);
				creativeObj.url = 'Dynamically generated display URL';
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.toUpperCase().includes('CALL_ONLY_AD')) {
				creativeObj.description = [];
				creativeObj.adHeadline = response.scaa_headline
					? response.scaa_headline.substring(0, 30)
					: response.headline
					? response.headline.substring(0, 30)
					: '';
				let descpt1 = response.scaa_description1
					? response.scaa_description1.substring(0, 90)
					: response.description1
					? response.description1.substring(0, 90)
					: '';
				let descpt2 = response.scaa_description2
					? response.scaa_description2.substring(0, 90)
					: response.description2
					? response.description2.substring(0, 90)
					: '';
				creativeObj.description.push(descpt1, descpt2);
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_display_url)
					? UtilityService.isUndefinedOrNull(response.display_url)
						? ''
						: response.display_url
					: response.scaa_display_url;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.length > 0) {
				let ad_headlines = [];
				creativeObj.description = [];
				ad_headlines.push(
					response.scaa_headline_part1
						? response.scaa_headline_part1.substring(0, 30)
						: response.headline_part1
						? response.headline_part1.substring(0, 30)
						: ''
				);
				ad_headlines.push(
					response.scaa_headline_part2
						? response.scaa_headline_part2.substring(0, 30)
						: response.headline_part2
						? response.headline_part2.substring(0, 30)
						: ''
				);
				ad_headlines.push(
					response.scaa_headline_part3
						? response.scaa_headline_part3.substring(0, 30)
						: response.headline_part3
						? response.headline_part3.substring(0, 30)
						: ''
				);
				creativeObj.adHeadline = ad_headlines.join(' | ');
				creativeObj.description.push(
					response.scaa_description
						? response.scaa_description.substring(0, 90)
						: response.description
						? response.description.substring(0, 90)
						: ''
				);
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_creative_final_urls)
					? UtilityService.isUndefinedOrNull(response.creative_final_urls)
						? ''
						: response.creative_final_urls
					: response.scaa_creative_final_urls;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			}
			creativePerformances.push(creativeObj);
		}

		let temp = [];

		if (this.isOverviewSem) {
			const formattedData = this.groupArrayOfObjectsByAdgroup(creativePerformances, 'adgroup_id');
			let adgroup_ids = Object.keys(formattedData);
			adgroup_ids.forEach((id, index) => {
				let eachAdgroup = formattedData[id];
				let ads = [];
				let combinations = [];
				eachAdgroup.forEach((element) => {
					if (element.ad_type != null && element.ad_type !== 'RESPONSIVE_SEARCH_AD' && element.ad_type !== '') {
						element.url = element.url
							? element.url.substring(
									element.url.indexOf('http') > -1
										? element.url.indexOf('http')
										: element.url.indexOf('www.') > -1
										? element.url.indexOf('www.')
										: 0,
									element.url.indexOf('"]')
							  )
							: '';
						ads.push(element);
					} else {
						if (element.ad_type == 'RESPONSIVE_SEARCH_AD') {
							element.url = element.url.substring(
								element.url.indexOf('http') > -1
									? element.url.indexOf('http')
									: element.url.indexOf('www.') > -1
									? element.url.indexOf('www.')
									: 0,
								element.url.indexOf('"]')
							);
							ads.push(element);
						}
					}
				});
				temp.push(...ads);
			});
			creativePerformances = temp;
		}

		return creativePerformances;
	}

	groupArrayOfObjectsByAdgroup(list, key) {
		return list.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}

	generateGraphData(index?: number): void {
		const graphData = [];
		let arrayIndex = index ? index : 0;
		const categories =
			this.creatives.length > 0
				? this.creatives[arrayIndex].graphData.dates
					? this.creatives[arrayIndex].graphData.dates
					: []
				: [];
		for (const creative of this.creatives) {
			if (creative) {
				const graphDataForCreative = [];
				this.legend.forEach((legendItem, index) => {
					const seriesObj: any = {};
					seriesObj['name'] = legendItem.displayName;
					seriesObj['id'] = creative.versionId;
					seriesObj['data'] = creative.graphData[legendItem.value] ? creative.graphData[legendItem.value] : [];
					seriesObj['color'] = this.getColorFromColorConfig(index + 1, 1);
					seriesObj['visible'] = index === 0 ? true : false;
					seriesObj['yAxis'] = 1;
					if (index === 0) {
						seriesObj['visible'] = true;
					}
					graphDataForCreative.push(seriesObj);
				});
				graphData.push({ series: graphDataForCreative, categories });
				creative.graphData = graphData;
			}
		}
	}

	processSelectedLegendItem(legendItem: any): void {
		const selectedLegend: any = _.findWhere(this.legend, { value: legendItem.value });
		selectedLegend.selected = !selectedLegend.selected;
	}

	previewCreative(creativeIndex: number): void {
		this.selectedCreative = this.creatives[creativeIndex];
		this.modalService.open('creative-preview-v1_' + this.key);
	}

	closeCreativePreview(modalId: string): void {
		this.modalService.close(modalId);
		this.selectedCreative = undefined;
	}

	resetLengends(index?: number): void {
		this.legend.forEach((legendItem: any, legendIndex: number) => {
			if (legendIndex === 0) {
				legendItem.selected = true;
				legendItem.active = true;
			} else {
				legendItem.selected = false;
				legendItem.active = false;
			}
		});
		this.processResponseData(this.responseData, index);
	}

	backBtn(index: number): void {
		if (this.creatives.length !== 1) {
			if (this.creatives[index - 1]) {
				this.carousel.moveTo(index - 1, false);
				this.resetLengends(index - 1);
			} else {
				this.carousel.moveTo(this.creatives.length - 1, false);
				this.resetLengends(this.creatives.length - 1);
			}
		}
	}

	nextBtn(index: number): void {
		if (this.creatives.length !== 1) {
			if (this.creatives[index + 1]) {
				this.carousel.moveTo(index + 1, false);
				this.resetLengends(index + 1);
			} else {
				this.carousel.moveTo(0, false);
				this.resetLengends(0);
			}
		}
	}
}
